import { render, staticRenderFns } from "./CatalogDemandDisabled.vue?vue&type=template&id=3f1c0d21&"
import script from "./CatalogDemandDisabled.vue?vue&type=script&lang=ts&"
export * from "./CatalogDemandDisabled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports